<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">快捷导航</span>
      </div>
      <el-row :gutter="0" align="left">
        <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="8">
              <span>可用余额：<span>{{ quicklyData.balanceMoney }}</span>元</span>
            </el-col>
            <el-col :span="6">
              <span>冻结资金：<span>{{ quicklyData.freezeMoney }}</span></span>
            </el-col>
            <el-col :span="8">
              <router-link  to="/home/salemancashd">查看资金明细</router-link>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <div style="height: 1rem"></div>
    <salemane-message-list :is-show-search-bar="false"></salemane-message-list>
  </div>
</template>

<script>
import salemaneMessageList from "./SalemaneMessageList";
import {queryBusinessQuicklyData} from "../../api/b2cbusiness/b2c_allquicklydata";

export default {
  name: "SalesmanFirstPage",
  components:{
    salemaneMessageList,
  },
  data() {
    return {
      quicklyData: {
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods:{
    getData(){
      queryBusinessQuicklyData().then(res=>{
        if (res.success) {
          console.log(res.data);
          this.quicklyData = res.data;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    }
  }
}
</script>

<style lang="scss" scoped>
span{
  color: red;
  span{
    margin: 5px;
    font-weight: bolder;
    font-size: 2rem;
  }
}
</style>
